(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breathewarm-14-footer-runtime"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const runtime = document.querySelector('[data-bw-runtime]');
    if (!runtime || runtime.dataset.bwBound === 'true') return;
    runtime.dataset.bwBound = 'true';
    const $ = (s, c = document) => c.querySelector(s);
    const $$ = (s, c = document) => [...c.querySelectorAll(s)];
    const rootUrl = runtime.dataset.rootUrl || '/';
    const currency = runtime.dataset.currency || 'USD';
    const productId = Number(runtime.dataset.productId || 0);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    const state = { variantId: 0, quantity: 1, totalCents: 0, lineKey: null };

    const announcement = $('#announcement');
    $('[data-close-announcement]')?.addEventListener('click', () => announcement?.remove());

    const mobileMenu = $('[data-mobile-menu]');
    const setMenu = open => {
      if (!mobileMenu) return;
      mobileMenu.classList.toggle('open', open);
      mobileMenu.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('menu-open', open);
    };
    $('[data-open-menu]')?.addEventListener('click', () => setMenu(true));
    $$('[data-close-menu]').forEach(el => el.addEventListener('click', () => setMenu(false)));

    const cartDrawer = $('[data-cart-drawer]');
    const setCart = open => {
      if (!cartDrawer) return;
      cartDrawer.classList.toggle('open', open);
      cartDrawer.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('cart-open', open);
    };
    $$('[data-open-cart]').forEach(el => el.addEventListener('click', async () => { await refreshCart(); setCart(true); }));
    $$('[data-close-cart]').forEach(el => el.addEventListener('click', () => setCart(false)));

    const graphicSvg = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="1000" height="1000"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#1e2a38"/><stop offset="1" stop-color="#6f8797"/></linearGradient><radialGradient id="h"><stop stop-color="#ffc078"/><stop offset=".35" stop-color="#d7643f" stop-opacity=".72"/><stop offset="1" stop-color="#d7643f" stop-opacity="0"/></radialGradient></defs><rect width="1000" height="1000" fill="url(#g)"/><circle cx="500" cy="480" r="310" fill="none" stroke="#aec2d6" stroke-opacity=".3" stroke-width="3"/><path d="M220 430c0-150 110-245 280-245s280 95 280 245v190c0 70-55 120-125 120H345c-70 0-125-50-125-120V430Z" fill="#424950"/><ellipse cx="365" cy="480" rx="90" ry="72" fill="#1e2a38" stroke="#626a72" stroke-width="20"/><ellipse cx="635" cy="480" rx="90" ry="72" fill="#1e2a38" stroke="#626a72" stroke-width="20"/><path d="M500 475 425 720h150L500 475Z" fill="#1e2a38"/><ellipse cx="500" cy="410" rx="250" ry="150" fill="url(#h)"/><ellipse cx="500" cy="610" rx="130" ry="180" fill="url(#h)"/><text x="500" y="875" fill="white" font-family="Arial" font-size="44" font-weight="700" text-anchor="middle">TARGETED WARMTH • HANDS-FREE COMFORT</text></svg>`)}`;

    const mainImage = $('#mainProductImage');
    $$('.thumb').forEach(btn => btn.addEventListener('click', () => {
      $$('.thumb').forEach(x => x.classList.remove('active'));
      btn.classList.add('active');
      if (!mainImage) return;
      mainImage.style.opacity = '.25';
      setTimeout(() => {
        mainImage.src = btn.dataset.image === 'graphic' ? graphicSvg : btn.dataset.image;
        mainImage.style.opacity = '1';
      }, 120);
    }));

    const form = $('.bw-product-form');
    const variantInput = $('[data-bw-variant-id]', form || document);
    const quantityInput = $('[data-bw-quantity]', form || document);
    const addButtons = $$('[data-add-cart]');
    const bundleInputs = $$('[data-bw-bundle-input]');
    const setSelectedBundle = input => {
      if (!input) return;
      input.checked = true;
      bundleInputs.forEach(el => el.closest('.bundle')?.classList.toggle('selected', el === input));
      state.variantId = Number(input.dataset.variantId || 0);
      state.quantity = Number(input.dataset.quantity || 1);
      state.totalCents = Number(input.dataset.totalCents || 0);
      if (variantInput) variantInput.value = String(state.variantId);
      if (quantityInput) quantityInput.value = String(state.quantity);
      $$('[data-button-total]').forEach(el => el.textContent = money(state.totalCents));
      $('[data-sticky-price]') && ($('[data-sticky-price]').textContent = money(state.totalCents));
      const available = input.dataset.available === 'true' && !input.disabled;
      addButtons.forEach(btn => {
        btn.disabled = !available;
        btn.setAttribute('aria-disabled', String(!available));
      });
    };
    bundleInputs.forEach(input => input.addEventListener('change', () => setSelectedBundle(input)));
    setSelectedBundle(bundleInputs.find(input => input.checked && !input.disabled) || bundleInputs.find(input => !input.disabled));

    const toast = $('[data-toast]');
    const showToast = message => {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(showToast.timer);
      showToast.timer = setTimeout(() => toast.classList.remove('show'), 1900);
    };

    const renderCart = cart => {
      $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const item = cart.items.find(line => Number(line.product_id) === productId) || cart.items[0];
      const filled = Boolean(item);
      $('[data-cart-empty]') && ($('[data-cart-empty]').hidden = filled);
      $('[data-cart-item]') && ($('[data-cart-item]').hidden = !filled);
      $('[data-cart-foot]') && ($('[data-cart-foot]').hidden = !filled);
      if (!item) { state.lineKey = null; return; }
      state.lineKey = item.key;
      const cartItem = $('[data-cart-item]');
      const image = $('img', cartItem);
      if (image && item.featured_image?.url) image.src = item.featured_image.url;
      if (image) image.alt = item.product_title || 'BreatheWarm';
      const title = $('h3', cartItem);
      if (title) title.textContent = item.product_title;
      $('[data-cart-bundle]') && ($('[data-cart-bundle]').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : `${item.quantity}-mask comfort set`);
      $('[data-cart-line-price]') && ($('[data-cart-line-price]').textContent = money(item.final_line_price));
      $('[data-cart-subtotal]') && ($('[data-cart-subtotal]').textContent = money(cart.total_price));
      $('[data-qty]') && ($('[data-qty]').textContent = item.quantity);
    };

    const refreshCart = async () => {
      const response = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load cart');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    const addSelected = async () => {
      if (!state.variantId) return;
      addButtons.forEach(btn => btn.disabled = true);
      try {
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: state.variantId, quantity: state.quantity }] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Could not add this item');
        await refreshCart();
        showToast('BreatheWarm added to cart');
        setTimeout(() => setCart(true), 220);
      } catch (error) {
        showToast(error.message || 'Could not add this item');
      } finally {
        const selected = bundleInputs.find(input => input.checked);
        const available = selected?.dataset.available === 'true' && !selected.disabled;
        addButtons.forEach(btn => btn.disabled = !available);
      }
    };

    form?.addEventListener('submit', event => { event.preventDefault(); addSelected(); });
    addButtons.filter(btn => !form?.contains(btn)).forEach(btn => btn.addEventListener('click', event => { event.preventDefault(); addSelected(); }));

    const changeCartLine = async delta => {
      if (!state.lineKey) return;
      const current = Number($('[data-qty]')?.textContent || 0);
      const quantity = Math.max(0, current + delta);
      const response = await fetch(`${rootUrl}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: state.lineKey, quantity })
      });
      if (!response.ok) return showToast('Could not update cart');
      renderCart(await response.json());
    };
    $('[data-qty-plus]')?.addEventListener('click', () => changeCartLine(1));
    $('[data-qty-minus]')?.addEventListener('click', () => changeCartLine(-1));
    $('[data-bw-checkout]')?.addEventListener('click', () => { window.location.href = `${rootUrl}checkout`; });

    $$('.faq-q').forEach(q => q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      const open = !item.classList.contains('open');
      item.classList.toggle('open', open);
      q.setAttribute('aria-expanded', String(open));
    }));

    const sticky = $('[data-sticky-atc]');
    const buy = $('#buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('visible', !entry.isIntersecting), { threshold: .1 });
      stickyObserver.observe(buy);
    }

    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        }
      }), { threshold: .12 });
      $$('.reveal').forEach(el => revealObserver.observe(el));
    } else {
      $$('.reveal').forEach(el => el.classList.add('in'));
    }

    refreshCart().catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
